import React from 'react'

import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'

export interface FeedBackOptionsObjProps {
  feedbackOptions: Array<string>
  groupAriaLabel: string
}

export interface FeedBackOptionsProps extends FeedBackOptionsObjProps {
  feedbackOptions: Array<string>
  groupAriaLabel: string
  selectedRadio?: number
  setSelectedRadio: React.Dispatch<React.SetStateAction<number | undefined>>
}

// Start of Main Component *************************************
export const FeedbackOptions: React.FC<FeedBackOptionsProps> = ({
  feedbackOptions,
  groupAriaLabel,
  selectedRadio,
  setSelectedRadio,
}) => {
  return (
    <FormControl
      sx={{
        p: 24,
        width: '100%',
      }}
    >
      <RadioGroup aria-label={groupAriaLabel} name="radio-buttons-group">
        {feedbackOptions.map((option, i) => (
          <Box
            key={i}
            sx={(theme) => ({
              p: '24px 0px 23px 0px',
              borderBottom: `1px solid ${theme.palette.divider}`,
            })}
          >
            <FormControlLabel
              control={
                <Radio
                  checked={selectedRadio === i}
                  name={`radio-${i}`}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    setSelectedRadio(Number(event.target.value))
                  }
                  size="small"
                  sx={(theme) => ({
                    color: theme.palette.secondary.light,
                    ml: 'auto',
                    p: '0px',
                    '& input.PrivateSwitchBase-input': {
                      opacity: 1,
                    },
                  })}
                />
              }
              key={i}
              label={option}
              labelPlacement="start"
              sx={{ ml: 0, p: '24px 0px 23px', width: '100%' }}
              value={i}
            />
          </Box>
        ))}
      </RadioGroup>
    </FormControl>
  )
}
